/* @ngInject */
export default function NvCourseThumbnail(
  InstitutionsManager,
) {
  return {
    restrict: 'A',
    scope: {
      course: '=',
    },
    controller: function ctrl($scope) {
'ngInject';
      const vm = this;
      vm.InstitutionsManager = InstitutionsManager;
    },
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: 'dashboard/templates/nv-course-thumbnail.html',
  };
}
